/**
 * @generated SignedSource<<13320f9a5d885c4cca91ef83a547b035>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type multimediaHomeV2Query$data = {
  readonly multimediaV2: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly entityId?: string;
          readonly types?: ReadonlyArray<{
            readonly value: ReadonlyArray<{
              readonly name: string;
            } | null | undefined> | null | undefined;
          } | null | undefined> | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"multimediaPodcastV2ContentItemContent" | "multimediaV2ContentItemContent">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "multimediaHomeV2Query";
};
export type multimediaHomeV2Query$key = {
  readonly " $data"?: multimediaHomeV2Query$data;
  readonly " $fragmentSpreads": FragmentRefs<"multimediaHomeV2Query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "multimediaQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "multimediaHomeV2Query",
  "selections": [
    {
      "alias": "multimediaV2",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "multimediaQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityId",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ArticleTypeSegment",
                              "kind": "LinkedField",
                              "name": "types",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ArticleType",
                                  "kind": "LinkedField",
                                  "name": "value",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "name",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "Article",
                          "abstractKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "multimediaPodcastV2ContentItemContent"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "multimediaV2ContentItemContent"
                        }
                      ],
                      "type": "Content",
                      "abstractKey": "__isContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:5)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f9668ce0f4bea5aa4c776632b91233ec";

export default node;
